export enum TextTriggerGroupType {
  Delivery = 'Delivery',
  Operation = 'Operation',
  ThreePL_Delivery = 'ThreePL_Delivery',
  ThreePL_Operation = 'ThreePL_Operation',
  Order = 'Order',
  Visit_Schedule = 'Visit_Schedule',
  Publish= 'Publish',
  FulfillmentLine = 'FulfillmentLine',
  Route = "Route"
}
